import { Spacing16, Spacing24 } from 'autogen/design-tokens/tokens';

const gap = Spacing24;
const sliderPadding = Spacing16;

// last number is amount of visible items, plus ~1/3
const widthFormulaXS = `calc(((100vw - (${gap} * 3)) - (${sliderPadding}) * 2) / 3.3)`;
const widthFormulaSM = `calc(((100vw - (${gap} * 4)) - (${sliderPadding}) * 2) / 4.3)`;
const widthFormulaMD = `calc(((100vw - (${gap} * 6)) - (${sliderPadding}) * 2) / 6.3)`;
const widthFormulaLG = `calc(((100vw - (${gap} * 8)) - (${sliderPadding}) * 2) / 8.3)`;

export { gap, sliderPadding, widthFormulaXS, widthFormulaSM, widthFormulaMD, widthFormulaLG };
